import React from 'react';
import {
  Table,
  Input,
  Dropdown,
  Menu,
  Button,
  Icon
} from 'antd';
import AccountRoleStationModalForm from './AccountRoleStationModalForm'
import AccountRoleGroupModalForm from './AccountRoleGroupModalForm'
import AccountLinkRoleSystem from './AccountLinkRoleSystem'
import {roleSuperAdmin} from '../constants/defaultValues'
import AccountLinnkDelete from './AccountLinnkDelete'
import {
  ROLE_HASH,
  ROLE_FILTER,
  ADMIN_ROLE,
  GROUP_MANAGEMENT_ROLE,
  GROUP_CONTROL_ROLE,
  GROUP_MONITORING_ROLE,
  STATION_MANAGEMENT_ROLE,
  STATION_CONTROL_ROLE,
  STATION_MONITORING_ROLE,
  PERMISSION_READ,
  PERMISSION_CONTROL,
  PERMISSION_UPDATE
} from '../constants/defaultValues'
import {locdau} from '../utils'
const SubMenu = Menu.SubMenu;
const highlight = {
  color: '#003a8c'
}

class AccountTableMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: this.props.accounts,
      selectedRowKeys: [],
      userNameFilterVisible: false,
      userNameSearchText: '',
      userNameFiltered: false,
      emailFilterVisible: false,
      emailSearchText: '',
      emailFiltered: false,
      accountSelected: undefined,
      visibleModalRoleStation: false,
      titleModalRoleStation: "Cài đặt quyền trạm",
      visibleModalRoleGroup: false,
      titleModalRoleGroup: "Cài đặt quyền địa bàn"
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({accounts: nextProps.accounts})
  }

  handleMenuSelection = (e, acc) => {
    this.props.onSelectionAccount(acc.ID)
    if (e.key === "1") {
      this.setState({accountSelected: acc, visibleModalRoleStation: true, titleModalRoleStation: `Cài đặt quyền trạm cho tài khoản [${acc.UserName}]`})
      return
    }
    if (e.key === "2") {
      this.setState({accountSelected: acc, visibleModalRoleGroup: true, titleModalRoleGroup: `Cài đặt quyền địa bàn cho tài khoản [${acc.UserName}]`})
      return
    }
  }

  handleCancel = () => {
    this.setState({visibleModalRoleStation: false, visibleModalRoleGroup: false});
  };

  handleUpdateRoleStaion = () => {
    const form = this.formRoleStation;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {selectedKeys, role} = values
      const {accountSelected} = this.state
      const access = role === STATION_MANAGEMENT_ROLE
        ? PERMISSION_UPDATE
        : role === STATION_CONTROL_ROLE
          ? PERMISSION_CONTROL
          : PERMISSION_READ
      const domains = selectedKeys.map((key) => {
        return {ID: key, Permission: access}
      })
      const permission = {
        AccountID: accountSelected.ID,
        SystemID: accountSelected.SystemID,
        Domains: domains,
        Role: role
      }
      this.props.onUpdatePermission(accountSelected, permission)
      form.resetFields();
      this.setState({visibleModalRoleStation: false});
    });
  };

  handleUpdateRoleGroup = () => {
    const form = this.formRoleGroup;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {selectedKeys, role} = values
      const {accountSelected} = this.state
      const access = role === GROUP_MANAGEMENT_ROLE
        ? PERMISSION_UPDATE
        : role === GROUP_CONTROL_ROLE
          ? PERMISSION_CONTROL
          : PERMISSION_READ
      const domains = selectedKeys.map((key) => {
        return {ID: key, Permission: access}
      })
      const permission = {
        AccountID: accountSelected.ID,
        SystemID: accountSelected.SystemID,
        Domains: domains,
        Role: role
      }
      this.props.onUpdatePermission(accountSelected, permission)
      form.resetFields();
      this.setState({visibleModalRoleGroup: false});
    });
  };

  handleUpdateRoleSystem = (account) => {
    const permission = {
      AccountID: account.ID,
      SystemID: account.SystemID,
      Domains: [],
      Role: ADMIN_ROLE
    }
    this.props.onUpdatePermission(account, permission)
  }

  saveFormRefRoleStation = (form) => {
    this.formRoleStation = form;
  };

  saveFormRefRoleGroup = (form) => {
    this.formRoleGroup = form;
  };

  onSelectChange = (selectedRowKeys) => {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({selectedRowKeys});
  }

  handleUserNameInputChange = (e) => {
    this.setState({userNameSearchText: e.target.value});
  };

  handleUserNameSearch = () => {
    const {userNameSearchText} = this.state
    const {accounts} = this.props
    const filterAccounts = accounts.filter((item) => {
      const lower = item.UserName.toLowerCase()
      const lowerSearch = userNameSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      return index > -1
    }).map((item) => {
      const lower = item.UserName.toLowerCase()
      const lowerSearch = userNameSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      const beforeStr = item.UserName.substr(0, index);
      const matchStr = item.UserName.substr(index, userNameSearchText.length);
      const afterStr = item.UserName.substr(index + userNameSearchText.length);
      const title = (<span>
        {beforeStr}
        <span className="highlight">{matchStr}</span>
        {afterStr}
      </span>)
      return {
        ...item,
        UserNameTitle: title
      };
    })
    this.setState({
      userNameFilterVisible: false,
      userNameFiltered: !!userNameSearchText,
      nameFiltered: false,
      nameSearchText: "",
      emailFiltered: false,
      emailSearchText: "",
      phoneFiltered: false,
      phoneSearchText: "",
      accounts: filterAccounts
    });
  };

  handleEmailInputChange = (e) => {
    this.setState({emailSearchText: e.target.value});
  };

  handleEmailSearch = () => {
    const {emailSearchText} = this.state
    const {accounts} = this.props
    const filterAccounts = accounts.filter((item) => {
      const lower = item.Email.toLowerCase()
      const lowerSearch = emailSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      return index > -1
    }).map((item) => {
      const lower = item.Email.toLowerCase()
      const lowerSearch = emailSearchText.toLowerCase()
      const index = lower.indexOf(lowerSearch);
      const beforeStr = item.Email.substr(0, index);
      const matchStr = item.Email.substr(index, emailSearchText.length);
      const afterStr = item.Email.substr(index + emailSearchText.length);
      const title = (<span>
        {beforeStr}
        <span className="highlight">{matchStr}</span>
        {afterStr}
      </span>)
      return {
        ...item,
        EmailTitle: title
      };
    })
    this.setState({
      emailFilterVisible: false,
      emailFiltered: !!emailSearchText,
      nameFiltered: false,
      nameSearchText: "",
      userNameFiltered: false,
      userNameSearchText: "",
      phoneFiltered: false,
      phoneSearchText: "",
      accounts: filterAccounts
    });
  };

  render() {
    const {
      role,
      fetching,
      groups,
      treeGroups,
      stations,
      permissions,
      fetchingGroups,
      fetchingStations,
      fetchingPermissions,
      onDelete
    } = this.props

    const {
      accounts,
      accountSelected,
      selectedRowKeys,
      userNameFiltered,
      userNameSearchText,
      userNameFilterVisible,
      emailFiltered,
      emailSearchText,
      emailFilterVisible
    } = this.state

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    };
    const columns = [
      {
        title: 'Tài khoản',
        dataIndex: 'UserName',
        key: 'username',
        render: (text, item, i) => (
          item.UserNameTitle
          ? item.UserNameTitle
          : item.UserName),
        filterDropdown: (<div className="table-filter-dropdown">
          <Input ref={ele => this.unameSearchInput = ele} placeholder="Nhập tài khoản" value={userNameSearchText} onChange={this.handleUserNameInputChange} onPressEnter={this.handleUserNameSearch}/>
          <Button type="primary" onClick={this.handlePhoneSearch}>Tìm</Button>
        </div>),
        filterIcon: <Icon type="search" style={userNameFiltered
            ? highlight
            : null}/>,
        filterDropdownVisible: userNameFilterVisible,
        onFilterDropdownVisibleChange: visible => this.setState({
          userNameFilterVisible: visible
        }, () => this.unameSearchInput.focus())
      }, {
        title: 'Email',
        dataIndex: 'Email',
        key: 'email',
        render: (text, item, i) => (
          item.EmailTitle
          ? item.EmailTitle
          : item.Email),
        filterDropdown: (<div className="table-filter-dropdown">
          <Input ref={ele => this.emailSearchInput = ele} placeholder="Nhập email" value={emailSearchText} onChange={this.handleEmailInputChange} onPressEnter={this.handleEmailSearch}/>
          <Button type="primary" onClick={this.handleEmailSearch}>Tìm</Button>
        </div>),
        filterIcon: <Icon type="search" style={emailFiltered
            ? highlight
            : null}/>,
        filterDropdownVisible: emailFilterVisible,
        onFilterDropdownVisibleChange: visible => this.setState({
          emailFilterVisible: visible
        }, () => this.emailSearchInput.focus())
      }, {
        title: '...',
        key: 'action',
        render: (text, item) => {
          const menu = (<Menu onClick={(e) => this.handleMenuSelection(e, item)}>
            <Menu.Item key="1">
              <span>
                <a role="button">Quyền trạm</a>
              </span>
            </Menu.Item>
            <Menu.Item key="2">
              <span>
                <a role="button">Quyền địa bàn</a>
              </span>
            </Menu.Item>
            {
              roleSuperAdmin(role)
                ? <Menu.Item key="3">
                    <AccountLinkRoleSystem account={item} onOk={this.handleUpdateRoleSystem}/>
                  </Menu.Item>
                : null
            }
            {
              roleSuperAdmin(role)
                ? <Menu.Divider/>
                : null
            }
            {
              roleSuperAdmin(role)
                ? <Menu.Item key="4">
                  <AccountLinnkDelete account={item} onDelete={onDelete}/>
                </Menu.Item>
                : null
            }
          </Menu>)
          return (<Dropdown overlay={menu} trigger={["click"]}>
            <a className="ant-dropdown-link" role="button">
              <Icon type="down"/>
            </a>
          </Dropdown>)
        }
      }
    ]
    const domains = permissions.map((permission) => {
      return permission.DomainID
    }) || []
    const domainStations = domains.map((id) => {
      const station = stations.find((item) => {
        return item.ID === id
      })
      return station
    }).filter((item) => {
      return item !== undefined
    })
    const removeDomainInStations = stations.filter((item) => {
      return domains.findIndex((id) => id === item.ID) < 0
    })
    const sortDomainsStations = domainStations.concat(removeDomainInStations)

    const roleAccountSelected = accountSelected
      ? accountSelected.Role
      : undefined
    return (<div><Table columns={columns} dataSource={accounts} rowKey={acc => acc.ID} loading={fetching}/>
      <AccountRoleStationModalForm isMobile={true} title={this.state.titleModalRoleStation} stations={sortDomainsStations} fetchingStations={fetchingStations} fetchingPermissions={fetchingPermissions} domains={domains} role={roleAccountSelected} groups={groups} ref={this.saveFormRefRoleStation} visible={this.state.visibleModalRoleStation} onCancel={this.handleCancel} onSubmit={this.handleUpdateRoleStaion}/>
      <AccountRoleGroupModalForm title={this.state.titleModalRoleGroup} treeGroups={treeGroups} groups={groups} fetchingGroups={fetchingGroups} fetchingPermissions={fetchingPermissions} domains={domains} role={roleAccountSelected} ref={this.saveFormRefRoleGroup} visible={this.state.visibleModalRoleGroup} onCancel={this.handleCancel} onSubmit={this.handleUpdateRoleGroup}/>
    </div>)
  }
}

export default AccountTableMobile



// WEBPACK FOOTER //
// ./src/components/AccountTableMobile.js